import _ from 'lodash';
import {
    FETCH_AI_AGENTS,
    CLEAN_AI_AGENTS,
    DELETE_AI_AGENT,
    RUN_AI_AGENT,
    PAUSE_AI_AGENT,
} from './types';
import { request, __ } from '../functions';
import {COOKIE_AI_AGENTS_NAME, COOKIE_SETTINGS} from "../config";

export const fetchAiAgents = (screen, options = {}) => {
    const { cookies } = screen.props;

    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/ai-agents', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        if (!_.isEmpty(sync.user) && _.has(sync.user, 'ai_agents')) {
            // Nastavime
            cookies.set(COOKIE_AI_AGENTS_NAME, sync.user.ai_agents.toString(), COOKIE_SETTINGS);
        }

        dispatch({ type: FETCH_AI_AGENTS, payload: data });
    });
};

export const runAiAgent = (screen, id) => {
    return dispatch => request(`/ai-agents/setWaiting/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa spustiť agenta'));
            return;
        }

        screen.showSnackbar('success', __('Agent bol spustený'));

        dispatch({ type: RUN_AI_AGENT, payload: id });
    });
};

export const pauseAiAgent = (screen, id) => {
    return dispatch => request(`/ai-agents/setPaused/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa pozastaviť agenta'));
            return;
        }

        screen.showSnackbar('success', __('Agent bol pozastavený'));

        dispatch({ type: PAUSE_AI_AGENT, payload: id });
    });
};

export const deleteAiAgent = (screen, id) => {
    return dispatch => request(`/ai-agents/remove/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmazať agenta'));
            return;
        }

        screen.showSnackbar('success', __('Agent bol zmazaný'));

        dispatch({ type: DELETE_AI_AGENT });
    });
};

export const cleanAiAgents = () => ({ type: CLEAN_AI_AGENTS });
